import PropTypes from 'prop-types';
import React from 'react';
import { Dialog } from 'react-toolbox';
import { connect } from 'react-redux';
import { clearValidationErrors, requestInstallersForAssignment,
          assignPhaseInstaller } from 'actionCreators';
import { getPhaseErrors } from '../../../../../../reducers';
import PhaseType from 'types/phase';
import { Button, IconButton } from 'react-toolbox/lib/button';
import StyledSelect from 'components/StyledSelect/react_select';
import TextArea from 'components/TextArea';
import S from 'modal.scss';
import styles from 'styles/input.scss';
import { generateSource } from '../../../../../../utils';

const REQUIRED_ERROR_MSG = 'Can\'t be blank.';
const DEFAULT_STATE = {
  selectedInstaller: '',
  comment: '',
  loading: false,
  errors: {},
};

class AssignInstallerModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.defaultState();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.active && !this.state.active && nextProps.active !== this.props.active) {
      this.props.requestInstallersForAssignment(this.props.phase.workroom.id,
        this.props.phase.zip_code);
    }
  }

  defaultState = () => ({
    ...DEFAULT_STATE,
    selectedInstaller: this.props.phase.installer_id,
  })

  validate = () => {
    const errors = {};
    const { selectedInstaller, comment } = this.state;
    if (!selectedInstaller) {
      errors.installer = REQUIRED_ERROR_MSG;
    }
    if (!comment || !comment.trim()) {
      errors.comment = REQUIRED_ERROR_MSG;
    }
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return false;
    }
    return true;
  }

  handleInstallerChange = (value) => {
    this.setState({ selectedInstaller: (value || {}).value });
  }

  handleCommentChange = (e) => {
    this.setState({ comment: e.target.value });
  }

  handleSubmit = () => {
    if (!this.validate()) return;
    const phase = this.props.phase;
    const { selectedInstaller, comment } = this.state;
    this.setState({ loading: true });
    this.props.assignPhaseInstaller(phase.id,
      { installer_id: selectedInstaller, note: comment })
      .then(() => this.handleClose())
      .catch(() => this.setState({ loading: false }));
  }

  handleClose = () => {
    this.props.clearValidationErrors('PHASE');
    this.setState(this.defaultState());
    this.props.onClose();
  }

  render = () => {
    const { active, installers, serverErrors, phase: { installer_id } } = this.props;
    const { selectedInstaller, comment, errors, loading } = this.state;
    const installerOptions = generateSource(installers);
    const label = installer_id > 0 ? 'Reassign Installer' : 'Assign Installer';
    return (<Dialog
      active={active}
      className={S.modal}
      type="fullscreen"
      onEscKeyDown={this.handleClose}
    >
      {serverErrors && Object.keys(serverErrors).length > 0 && <div className={styles.errored}>
        <span className={styles.error}>This action could not be completed.</span>
        <span>{errors.assign_installer}</span>
      </div>}
      <IconButton
        icon="close"
        className={S.close}
        onClick={this.handleClose}
        tabIndex={-1}
      />
      <h5 className={S.title}>{label}</h5>
      <StyledSelect
        className={S.commSelect}
        placeholder="Not Assigned"
        label="Installer Name *"
        onChange={this.handleInstallerChange}
        options={installerOptions}
        value={selectedInstaller}
        error={errors.installer}
      />
      <TextArea
        className={S.commSelect}
        label="Assignment Reason *"
        onChange={this.handleCommentChange}
        value={comment}
        errors={errors.comment ? [errors.comment] : []}
      />
      <div className={S.singleAction}>
        <Button
          label={label}
          flat inverse ripple
          className={S.action}
          onClick={this.handleSubmit}
          disabled={loading}
        />
      </div>
    </Dialog>
    );
  }
}

AssignInstallerModal.propTypes = {
  active: PropTypes.bool.isRequired,
  phase: PhaseType.isRequired,
  installers: PropTypes.array.isRequired,
  serverErrors: PropTypes.shape({}),
  clearValidationErrors: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  requestInstallersForAssignment: PropTypes.func.isRequired,
  assignPhaseInstaller: PropTypes.func.isRequired,
};

AssignInstallerModal.defaultProps = { active: false };

export default connect(
  state => ({
    serverErrors: getPhaseErrors(state),
    installers: (state.phase.details.installersForAssignment || []),
  }), {
    clearValidationErrors,
    requestInstallersForAssignment,
    assignPhaseInstaller,
  },
)(AssignInstallerModal);




// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/assignInstallerModal.jsx